import React, { useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import PageBase from '../../components/PageBase';
import PageTitle from '../components/PageTitle';
import { useTracking } from 'react-tracking';
import SiteSelect from '../../components/SiteSelect';
import AdviceTableCard from '../components/advice/AdviceTableCard';
import HealthAndSafetyIcon from '../components/icons/HealthAndSafetyIcon';

const useStyles = makeStyles((theme) => ({
    titleGrid: {
        marginBottom: theme.spacing(2),
    },
}));

export default function Advice() {
    const classes = useStyles();
    const { Track } = useTracking({
        page: 'H&S Advice',
    });

    return (
        <PageBase>
            <Track>
                <Grid
                    container
                    spacing={2}
                    justifyContent="space-between"
                    className={classes.titleGrid}
                >
                    <Grid item xs={12} md={9}>
                        <PageTitle
                            icon={<HealthAndSafetyIcon />}
                            title="H&S Advice"    />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <SiteSelect size="small" />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <AdviceTableCard />
                    </Grid>
                </Grid>
            </Track>
        </PageBase>
    );
} 